export interface ChatParticipantAddedEvent {
  id: string;
  type: 'participant_added';
  inviterAdminExternalId: string;
  inviterName: string;
  inviteeAdminExternalId: string;
  inviteeName: string;
  timestamp: unknown;
}

export interface ChatLastParticipantAddedActivity {
  type: 'participant_added';
  inviterAdminExternalId: string;
  inviterName: string;
  inviteeAdminExternalId: string;
  inviteeName: string;
}

export function formatParticipantAddedNote(
  event: Pick<ChatParticipantAddedEvent, 'inviterName' | 'inviteeName' | 'inviteeAdminExternalId'>,
  viewerAdminExternalId: string | null | undefined,
): string {
  if (viewerAdminExternalId && event.inviteeAdminExternalId === viewerAdminExternalId) {
    return `${event.inviterName} has added you to this chat`;
  }
  return `${event.inviteeName} was added to this chat`;
}

export function formatConversationPreviewText(
  conversation: {
    lastMessageText?: string | null;
    lastActivity?: ChatLastParticipantAddedActivity | null;
  },
  viewerAdminExternalId: string | null | undefined,
): string {
  if (conversation.lastActivity?.type === 'participant_added') {
    return formatParticipantAddedNote(conversation.lastActivity, viewerAdminExternalId);
  }
  return conversation.lastMessageText?.trim() || 'No messages yet';
}
